module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/126-botswana-adc091e908023cc05fdc084020513196.svg";